import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import FundOverview from "./sections/FundOverview";
import InvestmentStrategy from "./sections/InvestmentStrategy";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <FundOverview />
      <InvestmentStrategy />
      <Footer />
    </div>;
}